import { Button } from 'components/ui'
import React, { useState, useCallback } from 'react'
import { Flex, Text } from '@chakra-ui/core'
import UsersList from 'components/CommonComponents/UsersList'
import { SelectionMode } from 'components/CommonComponents/OptimizedGroupsTree/hooks/useSelection'
import useLocaleText from 'components/useLocaleText'
import { useSelector } from 'react-redux'
import { RootState } from 'constants/interfaces'
import { BaseModalV2 } from 'components/ui/BaseModal'

interface WatchersModalProps {
  isOpen: boolean
  onClose: () => void
  initialWatchers: string[]
  onSubmit: (selectedWatchers: string[]) => void
}

export const WatchersModal: React.FC<WatchersModalProps> = ({ isOpen, onClose, initialWatchers, onSubmit }) => {
  const [selectedWatchers, setSelectedWatchers] = useState<string[]>(initialWatchers)

  const theme = useSelector((state: RootState) => state.general.theme)
  const t_watchers = useLocaleText('watchers')

  const t_submit = useLocaleText('save') || 'Save'
  const t_cancel = useLocaleText('cancel') || 'Cancel'

  const handleSelectionChange = useCallback((selectedIds: string[]) => {
    setSelectedWatchers(selectedIds)
  }, [])

  const handleSubmit = useCallback(() => {
    onSubmit(selectedWatchers)
    onClose()
  }, [selectedWatchers, onSubmit, onClose])

  const handleClose = useCallback(() => {
    setSelectedWatchers(initialWatchers)
    onClose()
  }, [initialWatchers, onClose])

  return (
    <BaseModalV2
      isOpen={isOpen}
      onClose={handleClose}
      modalProps={{
        closeOnOverlayClick: false,
      }}
      modalOverlayProps={{
        zIndex: 10001,
      }}
      modalContentProps={{
        height: 'auto',
        maxW: '600px',
        zIndex: 10002,
      }}
      modalBodyProps={{ height: 'auto' }}
      header={
        <Text fontSize="18px" fontWeight="600">
          {t_watchers}
        </Text>
      }
      body={
        <UsersList
          showSearch={true}
          selectionMode={SelectionMode.MULTIPLE}
          initialSelectedIds={selectedWatchers}
          listHeight={400}
          onSelectionChange={handleSelectionChange}
          isShowTags={false}
        />
      }
      footer={
        <Flex w="100%" justifyContent="flex-end" style={{ gap: '12px' }}>
          <Button type="button" variant="ghost" onClick={handleClose}>
            {t_cancel}
          </Button>
          <Button type="button" bg={theme?.elementsColor} color="white" onClick={handleSubmit}>
            {t_submit}
          </Button>
        </Flex>
      }
    />
  )
}
